var $ = require('jquery');
// var styleguide = require('./modules/style-guide.js');
var accordions = require('./modules/accordions.js');
var aos = require('./modules/aos.js');
var cards = require('./modules/cards.js');
var fancyapps = require('./modules/fancyapps.js');
var map = require('./modules/map.js');
var menu = require('./modules/menu.js');
var scrollto = require('./modules/scrollto.js');
var sliders = require('./modules/sliders.js');
var stats = require('./modules/stats.js');
var svg = require('./modules/svg.js');
var tabs = require('./modules/tabs.js');

// Make sure that you init the styleguide first.
// styleguide.init();
accordions.init();
aos.init();
cards.init();
fancyapps.init();
map.init();
menu.init();
scrollto.init();
sliders.init();
stats.init();
svg.init();
tabs.init();